export default __webpack_public_path__ + "static/media/book-alt.11875b3f.svg";